import React, { useState, useRef, useEffect, Fragment } from 'react';
import './NavigationMenu.css';
import LeftMenu from '../../images/assets/menu-left.png'
import { AccordionBlock } from '../panels/USPFeatureDetails/usp_feature_details';
import Link from '../Link';
import { CartContext } from '../../context/shopContext';
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

const NavigationMenu = React.forwardRef(({ handleClose, data, menuOpen }, ref) => {
    const { menuItems, topLevelNavData } = data
    const isOpen = menuOpen
    const [firstStageSelectedIndex, setFirstStageSelectedIndex] = useState()
    const selectedFirstStage = menuItems[firstStageSelectedIndex]
    const handleFirstSelect = (index) => {
        setFirstStageSelectedIndex(index)
    }

    const handleFirstClick = (index) => {
        setFirstStageSelectedIndex(index)
    }

    const activeLink = useRef(null);
    const coords = useRef({ x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 });

    const isInsideTriangle = () => {
        const { x0, y0, x1, y1, x2, y2, x3, y3 } = coords.current;
        const b0 = (x2 - x1) * (y3 - y1) - (x3 - x1) * (y2 - y1);
        const b1 = ((x2 - x0) * (y3 - y0) - (x3 - x0) * (y2 - y0)) / b0;
        const b2 = ((x3 - x0) * (y1 - y0) - (x1 - x0) * (y3 - y0)) / b0;
        const b3 = ((x1 - x0) * (y2 - y0) - (x2 - x0) * (y1 - y0)) / b0;
        return b1 > 0 && b2 > 0 && b3 > 0;
    };

    const onmousemove = (index, event) => {
        const x0 = event.clientX;
        const y0 = event.clientY;
        coords.current = { ...coords.current, x0, y0 };

        // drawTriangleAndCircle()

        const closestListItem = event.target.closest('li');

        if (!isInsideTriangle()) {
            if (closestListItem && closestListItem.classList.contains('r1')) {
                if (!closestListItem.classList.contains(`item-${index}`)) {
                    coords.current = {
                        ...coords.current,
                        x1: x0,
                        y1: y0,
                    }
                    return
                }
                activeLink.current = closestListItem
                const nextMenu = document.getElementById('nmw-1');
                const next = nextMenu.getBoundingClientRect();
                handleFirstSelect(index)
                coords.current = {
                    x0,
                    y0,
                    x1: x0,
                    y1: y0,
                    x2: next.right,
                    y2: next.top + 100,
                    x3: next.right,
                    y3: next.bottom - 100
                }
            }
        }
    };

    const boundListeners = useRef({})
    const listenerCounter = useRef(0)

    const onmouseenter = (index) => {
        if (!boundListeners.current[index]) {
            boundListeners.current[index] = onmousemove.bind(null, index);
            document.addEventListener('mousemove', boundListeners.current[index]);
            listenerCounter.current += 1;
        }
    };

    const onmouseleave = (index) => {
        if (boundListeners.current[index]) {
            document.removeEventListener('mousemove', boundListeners.current[index]);
            delete boundListeners.current[index];
            listenerCounter.current -= 1; // Assuming you want to decrement here
        }
    };

    useEffect(() => {
        handleFirstSelect();
        if (!menuOpen) {
            for (const index in boundListeners.current) {
                if (boundListeners.current.hasOwnProperty(index)) {
                    document.removeEventListener('mousemove', boundListeners.current[index]);
                    listenerCounter.current -= 1; // Assuming you want to decrement for each removed listener
                }
            }
            boundListeners.current = {};
        }
    }, [menuOpen])

    return (
        <>
            <div
                className={`opac-cov ${menuOpen ? 'fade-in' : ''}`}
                onClick={handleClose}
            />
            <canvas id="triangle"></canvas>
            <div className={`menu-container ${isOpen ? 'open' : ''}`}>
                <div
                    className="navigation-container"
                    onMouseLeave={() => {
                        handleFirstSelect()
                    }}
                >

                    <div className="navigation-container-relative">
                        <div id="nmw-1" className={`navigation-menu-wrapper nmw-1 ${isOpen ? 'open' : ''}`} >
                            <nav className={`navigation-menu ${isOpen ? 'open' : ''}`}>
                                <ul className="menu-list mobile-scroll-padding" >
                                    {menuItems.map((item, key) => (
                                        <Fragment key={key}>
                                            {
                                                item?.items[0]?.items?.length === 0 ? (
                                                    <Link to={item.to} styles={{fontWeight: item.Highlight === true ? 600: 400}} className={`menu-item r1 item-${key} ${key === firstStageSelectedIndex ? 'open' : ''}`}>
                                                        {item.title}
                                                        <span style={{ color: '#ca7a4f', fontSize: 16 }}>
                                                            {" "}{item?.ItemLabel}
                                                        </span>
                                                    </Link>
                                                ) : (
                                                    <li
                                                        key={item.title}
                                                        onMouseEnter={() => {
                                                            if (menuItems[key]?.items && menuItems[key].items.length > 0) {
                                                                onmouseenter(key)
                                                            }
                                                        }}
                                                        onMouseLeave={onmouseleave(key)}
                                                        className={`menu-item r1 item-${key} ${key === firstStageSelectedIndex ? 'open' : ''}`}
                                                        onClick={() => item?.items[0]?.items?.length !== 0 && handleFirstClick(key)}
                                                    >
                                                        {
                                                            item?.items[0]?.items?.length === 0 ? (
                                                                <Link to={item.to}>
                                                                    {item.title}
                                                                    <span style={{ color: '#ca7a4f', fontSize: 16 }}>
                                                                        {" "}{item?.ItemLabel}
                                                                    </span>
                                                                </Link>
                                                            ) : (
                                                                <>
                                                                    <span className="main-menu-item">{item.title}</span><img className={`${key === firstStageSelectedIndex ? 'menu-arrow-left' : 'menu-arrow-right'}`} src={LeftMenu}></img>
                                                                </>
                                                            )
                                                        }
                                                    </li>
                                                )
                                            }
                                        </Fragment>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                        <div id="nmw-2" className={`navigation-menu-wrapper nmw-2 ${firstStageSelectedIndex !== undefined ? 'open' : ''}`}>
                            <nav className={`navigation--second-menu  ${firstStageSelectedIndex !== undefined ? 'open' : ''}`}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 16}}>
                                    <div onClick={() => setFirstStageSelectedIndex()} className='back-button'>{'Back'}</div>
                                    <div style={{fontWeight: 600, fontSize: 24}}> {selectedFirstStage?.title} </div>
                                    <div style={{width: 35}}/>
                                </div>
                                <ul className="menu-list mobile-scroll-padding" >
                                    {
                                        selectedFirstStage && (
                                            <Fragment key={`accordion-${firstStageSelectedIndex}`}>
                                                <AccordionBlock
                                                    textDecoration={false}
                                                    boldHeadings={true}
                                                    small={true}
                                                    data={{
                                                        AccordionItem: selectedFirstStage?.items.map((item, itemIndex) => {
                                                            return {
                                                                AccordionTitle: item.title,
                                                                AccordionCopy: (
                                                                    <ul className="menu-list" key={itemIndex}>
                                                                        {
                                                                            item?.items.map((thirdItem, index) => (
                                                                                <Link to={thirdItem.to}>
                                                                                    <li
                                                                                        key={`thirdItem-${index}`}
                                                                                        className={`menu-item open`}
                                                                                    >
                                                                                        <span className="menu-link">{thirdItem.title}
                                                                                            <span style={{ color: '#ca7a4f', fontSize: 16, textDecoration: 'underline' }}>
                                                                                                {" "}{thirdItem?.ItemLabel}
                                                                                            </span>
                                                                                        </span>
                                                                                    </li>
                                                                                </Link>
                                                                            ))
                                                                        }
                                                                    </ul>
                                                                )
                                                            }
                                                        })
                                                    }}
                                                />
                                                <br />
                                                {selectedFirstStage?.to && (
                                                    <Link to={selectedFirstStage.to}>
                                                        <li
                                                            className={`menu-item`}
                                                        >
                                                            <span className="menu-link">Shop All {selectedFirstStage.title}</span>
                                                        </li>
                                                    </Link>
                                                )}
                                                <br />
                                                {selectedFirstStage?.Tiles && (
                                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 4}}>
                                                        {
                                                            selectedFirstStage?.Tiles.map((tile, index) => {
                                                                return  (
                                                                    <Link to={tile.link} styles={{width: 'calc(50% - 4px)'}} key={index}>
                                                                        <div style={{width: '100%'}}>
                                                                            <GatsbyImage style={{aspectRatio: 1.3, width: '100%'}} image={getImage(tile.TileImage.file)} />
                                                                            <div className="menu-link">{tile.TileTitle}</div>
                                                                        </div>

                                                                    </Link>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                )}
                                            </Fragment>
                                        )
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default NavigationMenu;
